// extracted by mini-css-extract-plugin
module.exports = {"simlp5k":"simlp5k","w1ezmy8s":"w1ezmy8s","p1a187w2":"p1a187w2","h1hvmm35":"h1hvmm35","tizyv67":"tizyv67"};